import { NotificationService, useIntl } from '@capsicum/common';
import { Snackbar } from '@capsicum/common-web';
import { useRef } from 'react';

export const useTransactionErrorSnackbar = () => {
	const { $t } = useIntl();
	const hasSnackbarShown = useRef(false);

	const showTransactionErrorSnackbar = () => {
		if (hasSnackbarShown.current) return;

		hasSnackbarShown.current = true;
		NotificationService.addNotification({
			component: (
				<Snackbar
					description={$t('staking.snackbar.transactionError.description')}
					testID="stakeFanTokens-review-errorSnackbar"
					title={$t('staking.snackbar.transactionError.title')}
					variant="error"
				/>
			),
			persisted: true
		});
	};

	return {
		showTransactionErrorSnackbar
	};
};
